<template>
  <div class="page">
    <div class="header">
      <div class="header-content">
        <a class="logo-link" href="/">
          <img src="//assets.cnbj1.mi-fds.com/assets/emi/logo_n.png">
        </a>
        <a class="nav-item" href="/v2/dist/help.html">帮助中心</a>
      </div>
    </div>
    <div class="main">
      <p class="page-bread">帮助中心/{{categoryName}}</p>
      <div class="help-content">
        <div class="left">
          <el-collapse v-model="activeName" accordion @change="activeChange">
            <el-collapse-item v-for="q in questionList" :title="q.helpCategory.categoryName" :name="q.helpCategory.id" :key="q.helpCategory.id">
              <div class="question-item" :class="{'actived': question.id == questionId}" v-for="question in q.articleIdWithNameList" :key="question.id" @click="changeQuestion(question.id)">{{question.title}}</div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="right">
          <div class="question-content">
            <p class="title">{{questionData.title}}</p>
            <div class="content" v-html="questionData.content"></div>
          </div>
          <div class="question-action">
            <p class="desc">是否对您有帮助？</p>
            <el-button type="primary" size="medium" plain @click="actionHandle(1)">有用</el-button>
            <el-button type="primary" size="medium" plain @click="actionHandle(2)">无用</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios, { AccountInfo } from 'common/axios.js';
  import WebFlowWrapper from '@mi/web-flow-wrapper'
  export default {
    data () {
      return {
        activeName: '',
        categoryName: '',
        questionId: '',
        questionData: {
          title: '',
          content: ''
        },
        questionList: []
      }
    },
    watch: {
      questionId(id) {
        location.hash = id;
        this.getQuestionDetail(id);
      }
    },
    methods: {
      async getQuestionsList() {
        try {
          const {data: {result}} = await axios.get('/v2/help/list');
          this.questionList = result;
          const id = location.hash.substr(1);
          if (id) {
            for (let i = 0, len = this.questionList.length; i < len; i++) {
              const q = this.questionList[i];
              for (let j = 0, l = q.articleIdWithNameList.length; j < l; j++) {
                const question = q.articleIdWithNameList[j];
                if (id == question.id) {
                  this.activeName = q.helpCategory.id;
                  this.categoryName = q.helpCategory.categoryName;
                  this.questionId = id;
                  break;
                }
              }
              if (this.activeName) {
                break;
              }
            }
          } else {
            const q = this.questionList[0];
            this.activeName = q.helpCategory.id;
            this.categoryName = q.helpCategory.categoryName;
            this.questionId = q.articleIdWithNameList.length ? q.articleIdWithNameList[0].id : '';
          }
        } catch (e) {
          console.log(e);
        }
      },
      async activeChange(id) {
        if (!id) return;
        const activeQ = this.questionList.find(it => it.helpCategory.id == id);
        this.categoryName = activeQ.helpCategory.categoryName;
        const question = activeQ.articleIdWithNameList[0];
        if (question) {
          this.questionId = question.id;
        }
      },
      changeQuestion(id) {
        this.questionId = id;
        _hmt.push(['_trackEvent', 'select_help_page', 'article_id', id]);
      },
      async getQuestionDetail(id) {
        const {data: {result}} = await axios.get('/v2/help/detail', {params: {articleId: id}});
        if (result) {
          this.questionData = Object.assign(this.questionData, result);
        }
      },
      actionHandle(type) {
        const url = type == 1 ? '/v2/help/increaseUsefulCount' : 'v2/help/increaseUnUsefulCount';
        axios.post(url, {articleId: this.questionId});
      }
    },
    created() {
      this.getQuestionsList();      
      const { customerId } = AccountInfo.getAccountFromSys()
      console.log("🚀 ~ created ~ customerId:", customerId)
      if (customerId) {
        new WebFlowWrapper({
          biz: '/v2/dist/help.html',
          brand: true,
          debug: true,
        })
      }
    }
  }
</script>